import { Link } from "react-router-dom";
import { fmtGNF } from "@/lib/format";
import { mediaUrl } from "@/lib/api";
import { Layers, ShoppingBasket } from "lucide-react";
import { Stars } from "@/components/ProductReviews";

export const ProductCard = ({ product, onAdd }) => {
  const img = mediaUrl((product.images || [])[0]);
  const promo = product.compare_price && product.compare_price > product.price;
  const out = (product.stock || 0) <= 0;

  return (
    <div className="ds-card group flex flex-col overflow-hidden hover:-translate-y-0.5" data-testid={`product-card-${product.id}`}>
      <Link to={`/produit/${product.id}`} className="relative block aspect-square overflow-hidden bg-slate-100">
        {img ? (
          <img
            src={img}
            alt={product.name}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        ) : (
          <div className="flex h-full items-center justify-center text-slate-300">
            <ShoppingBasket className="h-10 w-10" />
          </div>
        )}
        <div className="absolute left-2 top-2 flex flex-col gap-1">
          {promo && <span className="ds-chip border-rose-300 bg-rose-600 text-white">Promo</span>}
          {product.wholesale_price && (
            <span className="ds-chip border-gold bg-gold-light text-gold-dark">
              <Layers className="h-3 w-3" /> Gros
            </span>
          )}
        </div>
        {out && (
          <div className="absolute inset-0 flex items-center justify-center bg-white/70 text-sm font-semibold text-slate-600">
            Rupture de stock
          </div>
        )}
      </Link>

      <div className="flex flex-1 flex-col p-4">
        <p className="text-[11px] font-medium uppercase tracking-wider text-brand">{product.category_name}</p>
        <Link
          to={`/produit/${product.id}`}
          className="mt-1 line-clamp-2 text-sm font-semibold leading-snug text-slate-900 hover:text-brand"
        >
          {product.name}
        </Link>
        <div className="mt-2">
          {product.rating_count > 0 && (
            <p className="mb-1 flex items-center gap-1 text-[11px] text-slate-500" data-testid={`card-rating-${product.id}`}>
              <Stars value={product.rating_avg} size="h-3 w-3" />
              <span className="font-num">({product.rating_count})</span>
            </p>
          )}
          <p className="font-num text-base font-bold text-brand sm:text-lg">{fmtGNF(product.price)}</p>
          {promo && <p className="font-num text-xs text-slate-400 line-through">{fmtGNF(product.compare_price)}</p>}
          {product.wholesale_price && product.wholesale_min_qty && (
            <p className="font-num mt-1 inline-flex rounded-md bg-gold-light px-1.5 py-0.5 text-[11px] font-semibold text-gold-dark">
              Gros dès {product.wholesale_min_qty} pcs : {fmtGNF(product.wholesale_price)}
            </p>
          )}
        </div>
        <button
          type="button"
          disabled={out}
          onClick={() => onAdd?.(product)}
          data-testid={`add-to-cart-${product.id}`}
          className="ds-btn-primary mt-3 w-full text-xs sm:text-sm"
        >
          <ShoppingBasket className="h-4 w-4" /> Ajouter
        </button>
      </div>
    </div>
  );
};

export const ProductSkeleton = () => (
  <div className="ds-card overflow-hidden">
    <div className="aspect-square animate-pulse bg-slate-200" />
    <div className="space-y-2 p-3">
      <div className="h-3 w-1/2 animate-pulse rounded bg-slate-200" />
      <div className="h-4 w-full animate-pulse rounded bg-slate-200" />
      <div className="h-8 w-full animate-pulse rounded bg-slate-200" />
    </div>
  </div>
);
